import { render, staticRenderFns } from "./ResultsPathways.vue?vue&type=template&id=779415c3&"
import script from "./ResultsPathways.vue?vue&type=script&lang=js&"
export * from "./ResultsPathways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports